<template>
    <div class="box">
        <div class="loading-spinner-outer" v-if="saving_file_number > 0">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file {{ saving_file_number }} of {{ attachments.length }}, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box-content">
            <h2 class="txt-primary mt-0">Step 1) Enter Lead Details</h2>
            <p>
                Enter details of this lead, you will be able to search for users to assign it to in the next step.
            </p>
            <div class="leads-list-item _create">
                <div class="content">
                    <div class="top">
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>System:</strong>
                                <select class="form-control" v-model="lead.epwin_system_type_id">
                                    <option :value="''">
                                        N/A
                                    </option>
                                    <option v-for="system_type in system_types" :value="system_type.id">
                                        {{ system_type.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>Type:</strong>
                                <select class="form-control" v-model="lead.type">
                                    <option value="homeowner">Homeowner</option>
                                    <option value="installer">Installer</option>
                                    <option value="commercial">Commercial</option>
                                </select>
                            </div>
                        </div>
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>Source:</strong>
                                <select class="form-control" v-model="lead.source">
                                    <option value="Social Media">Social Media</option>
                                    <option value="Website">Website</option>
                                    <option value="Phone">Phone</option>
                                    <option value="Direct Marketing">Direct Marketing</option>
                                    <option value="PR">PR</option>
                                    <option value="Email">Email</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="contact-details">
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>Name</strong>
                                <input type="text" class="form-control" v-model="lead.name">
                            </div>
                        </div>
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>Email:</strong>
                                <input type="text" class="form-control" v-model="lead.email">
                            </div>
                        </div>
                        <div class="lead-input-box p-3" v-if="lead.type === 'homeowner'">
                            <div>
                                <strong>Phone:</strong>
                                <input type="text" class="form-control" v-model="lead.phone">
                            </div>
                        </div>
                    </div>
                    <div class="address">
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>Address:</strong>
                                <input type="text" class="form-control" v-model="lead.address">
                            </div>
                        </div>
                        <div class="lead-input-box p-3">
                            <div>
                                <strong>Postcode:</strong>
                                <input type="text" class="form-control" v-model="lead.postcode">
                            </div>
                        </div>
                    </div>
                    <div class="lead-input-box p-3">
                        <strong>Details: </strong>
                        <textarea rows="6" class="form-control" v-model="lead.details"></textarea>
                    </div>
                    <div class="lead-input-box p-3">
                        <div class="form-group mb-0">
                            <label>Upload Files</label>
                            <div class="full-width">
                                <form :action="`${$aws_upload_url}`" method="post"
                                      enctype="multipart/form-data" id="amazon_form">
                                    <input type="hidden" name="policy" :value="aws_policy">
                                    <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                    <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                    <input type="hidden" name="x-amz-date" :value="aws_date">
                                    <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                    <input type="hidden" name="acl" value="private">
                                </form>
                                <vue-dropzone
                                        ref="fileUploadDropzone"
                                        id="dropzone"
                                        :options="dropzoneOptions"
                                        v-on:vdropzone-file-added="fileAddedToDropZone"
                                        v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                        :useCustomSlot="true"
                                >
                                    <div>
                                        <div class="mb-3">
                                            DRAG AND DROP FILES
                                        </div>
                                        <div class="mb-3">
                                            OR
                                        </div>
                                        <div>
                                            <a class="btn-secondary-outline">
                                                Choose files
                                            </a>
                                        </div>
                                    </div>
                                </vue-dropzone>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="mt-6 mb-6">
            <div class="align-right">
                <a class="btn-primary" @click.prevent="save()">
                    Create and Assign Lead
                </a>
            </div>
        </div>
    </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone';

  export default {
    props: [
      'logged_in_user',
      'system_types',
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
    ],
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    data() {
      return {
        saving: false,
        lead: {
          type: 'homeowner',
          lead_status_id: 1, //pending
          source: 'Social Media',
        },
        attachments: [],
        attachment_info: [],
        saving_file_number: 0,
        uploaded_file: null,
        dropzoneOptions: {
          url: '/',
          autoProcessQueue: false,
          uploadMultiple: true,
          saving_file_number: 0,
          addRemoveLinks: true,
        },
      }
    },
    methods: {
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.' + extension, '');

        let new_upload = {};

        new_upload.name = original_file_name;
        const filename = 'lead_attachments/' + original_file_name + '_' + Date.now();
        new_upload.filename = filename + '.' + extension;

        new_upload.filetype = uploadedFile.type;
        new_upload.uploaded_file = uploadedFile;

        this.attachments.push(new_upload);
        this.attachment_info.push({
          original_file_name: original_file_name,
          filename: filename + '.' + extension,
        });
      },
      fileRemovedFromDropZone(file) {
        const extension = file.name.replace(/^.*\./, '');
        const original_file_name = file.name.replace('.' + extension, '');
        this.attachments = this.attachments.filter(attachment => attachment.name !== original_file_name);
        this.attachment_info = this.attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
      },
      async save() {
        this.saving = true;

        const validationErrors = Validate({
          'Name': this.lead.name,
          'Email': this.lead.email,
          'Details': this.lead.details,
        }, {
          'Name': {
            presence: {
              allowEmpty: false,
            },
          },
          'Email': {
            presence: {
              allowEmpty: false,
            },
            email: true,
          },
          'Details': {
            presence: {
              allowEmpty: false,
            },
          },
        });

        if (validationErrors) {
          this.saving = false;
          Swal.fire({
            title: 'Unable to create lead',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        if(this.lead.postcode.toLowerCase() === "ireland") {
          this.lead.northings = 20;
          this.lead.eastings = 20;
          await this.processAttachments();
        } else {
          axios.get(`https://api.postcodes.io/postcodes/${this.lead.postcode}`).then(async (response) => {
            if(response.data.result.country === 'Northern Ireland') {
              this.lead.northings = 20;
              this.lead.eastings = 20;
            } else {
              this.lead.northings = response.data.result.northings;
              this.lead.eastings = response.data.result.eastings;
            }

            await this.processAttachments();

          }).catch(() => {
            this.saving = false;
            Swal.fire({
              title: 'Invalid Postcode',
              icon: 'warning',
            });
          });
        }
      },
      saveLead() {
        this.saving = true;
        axios.post('/leads/create', {
          lead: this.lead,
          attachments: this.attachment_info,
        }).then((response) => {
          window.location.href = `/leads/assign/${response.data}`;
        });
      },
      async processAttachments() {
        if (this.attachments.length < 1) {
          this.saveLead();
          return;
        }

        this.saving = false;
        this.saving_file_number = 1;

        await this.attachments.forEach(async (upload, index) => {
          let form_data = new FormData(document.querySelector('#amazon_form'));
          form_data.append('Content-Type', upload.filetype);
          form_data.append('key', upload.filename);
          form_data.append('file', upload.uploaded_file);

          await axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: form_data,
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(async () => {
            if (this.saving_file_number === this.attachments.length) {
              this.saving_file_number = 0;
              this.saveLead();
            } else {
              this.saving_file_number = this.saving_file_number + 1;
            }
          });
        });
      }
    },
  };
</script>
